module.exports = __webpack_public_path__ + "static/media/couple_in_house_mobile.f2e9c224.jpg";